import React from 'react';
import { Props } from '../types';

type MetroWidgetProps = Props<{
  headline: string,
  intro_text: string,
  immunology_image: string,
  immunology_groups_url: string,
  immunology_tests_url: string,
  clinical_image: string,
  clinical_groups_url: string,
  clinical_tests_url: string,
  select_tab?: string,
  select_group?: string,
  select_test?: string,
}>;

export const RocheMetroWidget = ({ blok }: MetroWidgetProps): JSX.Element => {
  const maps = [
    {
      title: 'Immunologie',
      code: 'immunology',
      svg: blok.immunology_image,
      groups: blok.immunology_groups_url,
      tests: blok.immunology_tests_url,
      theme: 'peach',
    },
    {
      title: 'Klinische Chemie',
      code: 'clinical',
      svg: blok.clinical_image,
      groups: blok.clinical_groups_url,
      tests: blok.clinical_tests_url,
      theme: 'ice',
    },
  ];
  return (
    <roche-metro-widget
      headline={blok.headline}
      intro-text={blok.intro_text}
      maps={JSON.stringify(maps)}
      full-height={true}
      select-tab={blok.select_tab}
      select-group={blok.select_group}
      select-test={blok.select_test}
    />
  );
};
